import { wrapDisplayName, withProps } from 'recompose'

export const withRouteParams = withProps(props => ({
    ...(props.match && props.match.params ? props.match.params : {}),
    ...(props.location ? props.location.query : {}),
}))

export const loadOnMount =
    (actionName, argsFromProps = () => [], test = () => true) =>
    WrappedComponent => {
        const LoadOnMountComponent = props => {
            React.useEffect(() => {
                if (test(props)) {
                    props[actionName](...argsFromProps(props))
                }
            }, [])

            return <WrappedComponent {...props} />
        }

        LoadOnMountComponent.displayName = wrapDisplayName(WrappedComponent, 'loadOnMount')

        LoadOnMountComponent.propTypes = {
            children: PropTypes.any,
            [actionName]: PropTypes.func.isRequired,
        }

        return LoadOnMountComponent
    }
